export const phieuXuatKho = {
  sections: {
    list: { title: 'Phiếu xuất kho' },
    xuatHuy: { title: 'Phiếu xuất hủy' },
    xuatTraNcc: { title: 'Phiếu xuất trả NCC' },
    detail: { title: 'Chi tiết phiếu xuất kho' },
    lines: 'Hàng hóa xuất',
  },
  titles: {
    add: 'Thêm mới',
    addNew: 'Thêm mới',
    addXuatHuy: 'Tạo phiếu xuất hủy',
    addXuatTraNcc: 'Tạo phiếu xuất trả NCC',
  },
  columns: {
    tongSoLuong: 'Tổng số lượng',
    summary: 'Thông tin',
    status: 'Trạng thái',
    ngayTao: 'Ngày tạo',
    ngayCapNhat: 'Ngày cập nhật',
    code: 'Mã phiếu',
    chiNhanh: 'Chi nhánh',
    loaiPhieu: 'Loại phiếu',
    ngayChungTu: 'Ngày chứng từ',
    nhaCungCap: 'Nhà cung cấp',
    khachHang: 'Khách hàng',
    chiNhanhDoi: 'Chi nhánh đối ứng',
    trangThai: 'Trạng thái',
    tongTienHang: 'Tổng tiền hàng',
    maHoaDon: 'Mã hóa đơn',
  },
  placeholders: {
    toolbarSearch: 'Tìm kiếm',
    maLoRequired: 'Bắt buộc (hàng quản lý theo hạn)',
    maLoOptional: 'Để trống nếu không theo lô',
  },
  aria: {
    columnPicker: 'Chọn cột hiển thị',
  },
  fields: {
    code: 'Mã phiếu',
    chiNhanh: 'Chi nhánh',
    loaiPhieu: 'Loại phiếu',
    ngayChungTu: 'Ngày chứng từ',
    nhaCungCap: 'Nhà cung cấp',
    khachHang: 'Khách hàng',
    chiNhanhDoi: 'Chi nhánh đối ứng',
    lyDo: 'Lý do',
    ghiChu: 'Ghi chú',
    phieuChuyen: 'Phiếu chuyển',
    status: 'Trạng thái',
    totalAmount: 'Tổng tiền hàng',
    product: 'Hàng hóa',
    productCode: 'Mã SP',
    productName: 'Tên SP',
    productSearch: 'Tìm mã / tên hàng',
    qty: 'SL sản phẩm',
    unitPrice: 'Đơn giá xuất kho',
    donGiaXuatKho: 'Đơn giá xuất kho',
    donGiaVon: 'Đơn giá vốn',
    donViTinhMua: 'Đơn vị tính mua',
    giamGia: 'Giảm giá',
    giamGiaPhieu: 'Giảm giá phiếu',
    tongSauGiamGia: 'Thành tiền',
    maLo: 'Serial/IMEI',
    hanSuDung: 'Date sản phẩm',
    serialImei: 'Serial/IMEI',
    dateSanPham: 'Date sản phẩm',
    lineAmount: 'Thành tiền',
    lineGhiChu: 'Ghi chú',
    createdAt: 'Ngày tạo',
    updatedAt: 'Ngày cập nhật',
    actions: 'Thao tác',
  },
  loaiPhieu: {
    XUAT_BAN: 'Xuất bán',
    XUAT_CHUYEN: 'Xuất chuyển kho',
    XUAT_TRA_NCC: 'Xuất trả NCC',
    XUAT_HUY: 'Xuất hủy',
    XUAT_NOI_BO: 'Xuất nội bộ',
    XUAT_DIEU_CHINH: 'Xuất điều chỉnh',
    XUAT_KHAC: 'Xuất khác',
  },
  detailTabs: {
    chung: 'Chung',
    generalInfo: 'Thông tin',
    chiTietHang: 'Chi tiết hàng',
    lines: 'Hàng hóa xuất',
  },
  form: {
    loaiPhieu: 'Loại phiếu',
    maPhieu: 'Mã phiếu',
    maPhieuAuto: 'Tự sinh khi lưu',
    ngayChungTu: 'Ngày chứng từ',
    nhaCungCap: 'Nhà cung cấp',
    khachHang: 'Khách hàng',
    chonKhachHang: 'Chọn khách hàng',
    chiNhanhDoi: 'Chi nhánh đối ứng',
    lyDo: 'Lý do',
    ghiChu: 'Ghi chú phiếu',
    note: 'Ghi chú phiếu',
    sectionHeader: 'Thông tin chung',
    sectionLines: 'Hàng hóa xuất',
    sectionSummary: 'Tổng hợp',
    product: 'Hàng hóa',
    productSearch: 'Tìm mã / tên hàng',
    qty: 'SL sản phẩm',
    unitPrice: 'Đơn giá xuất kho',
    donGiaXuatKho: 'Đơn giá xuất kho',
    donGiaVon: 'Đơn giá vốn',
    donViTinhMua: 'Đơn vị tính mua',
    maSp: 'Mã SP',
    tenSp: 'Tên SP',
    giamGia: 'Giảm giá',
    giamGiaPhieu: 'Giảm giá phiếu',
    tongSauGiamGia: 'Thành tiền',
    maLo: 'Serial/IMEI',
    hanSuDung: 'Date sản phẩm',
    serialImei: 'Serial/IMEI',
    dateSanPham: 'Date sản phẩm',
    lineNote: 'Ghi chú',
    lineAmount: 'Thành tiền',
    tongTienHang: 'Tổng tiền hàng',
    tongSoMatHang: 'Số mặt hàng',
    tongSoLuong: 'Tổng số lượng',
    lineCount: '{count} dòng',
    save: 'Lưu',
    lotRequired: 'Bắt buộc số lô (hàng quản lý HSD)',
    expiryRequired: 'Bắt buộc hạn sử dụng (hàng quản lý HSD)',
  },
  status: {
    phieuTam: 'Phiếu tạm',
    daHoanThanh: 'Đã xuất',
    daHuy: 'Đã hủy',
  },
  filter: {
    maKhachHang: 'Mã khách hàng',
    tenKhachHang: 'Tên khách hàng',
    maHangHoa: 'Mã sản phẩm',
    tenHangHoa: 'Tên sản phẩm',
    title: 'Lọc',
    loaiPhieu: 'Loại phiếu',
    trangThai: 'Trạng thái',
    khachHang: 'Khách hàng',
    tuNgay: 'Từ ngày',
    denNgay: 'Đến ngày',
    fromDate: 'Từ ngày',
    toDate: 'Đến ngày',
    dateRangePlaceholder: 'Chọn khoảng ngày',
    all: 'Tất cả',
    reset: 'Đặt lại',
    sortDir: 'Thứ tự',
    asc: 'Tăng dần',
    desc: 'Giảm dần',
    advancedTitle: 'Bộ lọc chi tiết',
  },
  actions: {
    complete: 'Hoàn thành',
    cancelVoucher: 'Hủy phiếu',
    copy: 'Sao chép phiếu',
    addLine: 'Thêm dòng trống',
    importExcel: 'Nhập Excel',
    downloadTemplate: 'Tải file mẫu',
    dongY: 'Đồng ý',
  },
  messages: {
    soKhongDuocAm: 'Số lượng / đơn giá không được âm.',
    loadError: 'Không tải được danh sách phiếu xuất kho.',
    noData: 'Chưa có phiếu xuất kho nào.',
    listSummary: 'Tổng số phiếu: {count}',
    createSuccess: 'Đã tạo phiếu xuất kho và trừ tồn.',
    updateSuccess: 'Đã cập nhật phiếu xuất kho.',
    deleteSuccess: 'Đã xóa phiếu xuất kho.',
    needLines: 'Vui lòng thêm ít nhất một dòng hàng hóa.',
    needNgayChungTu: 'Chọn ngày chứng từ trước khi lưu.',
    validateNgayChungTuBeforeNgayTao: 'Ngày chứng từ không hợp lệ.',
    needKhachHang: 'Chọn khách hàng trước khi lưu.',
    needNhaCungCap: 'Chọn nhà cung cấp trước khi lưu.',
    needChiNhanhDoi: 'Chọn chi nhánh đối ứng trước khi lưu.',
    needMaSp: 'Nhập mã SP cho mọi dòng hàng.',
    needTenSp: 'Nhập tên SP cho mọi dòng hàng.',
    needSoLuong: 'Nhập số lượng sản phẩm (> 0) cho mọi dòng.',
    needDonViTinhMua: 'Nhập đơn vị tính mua cho mọi dòng hàng.',
    needMaLo: 'Nhập Serial/IMEI cho hàng {code}.',
    needHanSuDung: 'Nhập date sản phẩm cho hàng {code}.',
    completeSuccess: 'Đã hoàn thành phiếu xuất kho.',
    cancelVoucherSuccess: 'Đã hủy phiếu xuất kho.',
    notFound: 'Không tìm thấy phiếu.',
    noLines: 'Chưa có dòng hàng hóa.',
    loadingLines: 'Đang tải dòng hàng…',
    confirmDelete: 'Xóa phiếu {name}?',
    confirmComplete: 'Hoàn thành phiếu {name}? Tồn kho sẽ được cập nhật.',
    vuotTonTitle: 'Số lượng xuất vượt tồn kho — tồn kho sẽ bị âm',
    vuotTonDong: '{ma} – {ten}: xuất {soLuong}, tồn {ton}',
    importDescription:
      'Tải file mẫu, điền mã hàng / số lượng / đơn giá / giảm giá. Một file tạo một phiếu tạm. Có thể nhập trực tiếp hoặc xem trước để chỉnh sửa.',
    importSuccess: 'Đã nhập hàng hóa từ Excel.',
    importWillCreate: 'Sẽ tạo 1 phiếu xuất kho từ {count} dòng hàng.',
    importPreviewProgress: 'Xem trước phiếu xuất',
    importPreviewLoading: 'Đang chuẩn bị phiếu xuất…',
    importPreviewDone: 'Đã tạo phiếu xuất từ xem trước.',
    confirmCancelVoucher: 'Hủy phiếu {name}? Tồn kho đã trừ sẽ được hoàn lại. Hành động không thể hoàn tác.',
  },
}
